import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectCidade } from '../../app/slices/cidadesSlice';
import { fecharModalAjuda } from '../../app/slices/modalSlice';
import { ContainerJanela, Divisor, Linha } from '../../styles/base';
import { replaceTags } from '../../util/stringFactory';
import Botao from '../Botao/Botao';
import { Ajuda, JanelaAjuda, TituloAjuda } from './ModalAjudaEstilo';

const ModalAjuda = ({ sic, zeladoria }) => {
  const dispatch = useDispatch();
  const dadosCidade = useSelector(selectCidade);

  if (sic) {
    return (
      <ContainerJanela>
        <JanelaAjuda className="controle-fundo controle-modal">
          <Linha style={{ justifyContent: 'flex-end' }}>
            <Botao
              fechar
              onClick={() => dispatch(fecharModalAjuda())}
            />
          </Linha>

          <TituloAjuda>SIC - Ajuda</TituloAjuda>

          <Divisor />

          {dadosCidade.configuracoes.TextoAjudaSic ? (
            <Ajuda className="controle-fundo">
              <div dangerouslySetInnerHTML={{ __html: dadosCidade.configuracoes.TextoAjudaSic }} />
            </Ajuda>
          ) : (
            <Ajuda className="controle-fundo">
              O SIC, Sistema de Informações ao Cidadão, por meio de um simplificado formulário de solicitação, permite que qualquer pessoa, física ou jurídica, possa solicitar acesso a informações e documentos do Poder Executivo conforme Lei nº 12.527 de 18 de Novembro de 2011. Por meio do SIC, além de fazer o pedido, será possível acompanhar o prazo pelo número de protocolo gerado e receber a resposta da solicitação por e-mail; entrar com recursos, apresentar reclamações e consultar as respostas recebidas.
            </Ajuda>
          )}

        </JanelaAjuda>
      </ContainerJanela>
    );
  }

  if (zeladoria) {
    return (
      <ContainerJanela>
        <JanelaAjuda className="controle-fundo controle-modal">
          <Linha style={{ justifyContent: 'flex-end' }}>
            <Botao
              fechar
              onClick={() => dispatch(fecharModalAjuda())}
            />
          </Linha>

          <TituloAjuda>Zeladoria - Ajuda</TituloAjuda>

          <Divisor />

          {dadosCidade.configuracoes.TextoAjudaZeladoria && (
            <Ajuda className="controle-fundo">
              <div dangerouslySetInnerHTML={{ __html: dadosCidade.configuracoes.TextoAjudaZeladoria }} />
            </Ajuda>
          )}

        </JanelaAjuda>
      </ContainerJanela>
    );
  }

  return (
    <ContainerJanela>
      <JanelaAjuda className="controle-fundo controle-modal">
        <Linha style={{ justifyContent: 'flex-end' }}>
          <Botao
            fechar
            onClick={() => dispatch(fecharModalAjuda())}
          />
        </Linha>

        <TituloAjuda>Ouvidoria - Ajuda</TituloAjuda>

        <Divisor />

        {dadosCidade.configuracoes.TextoAjudaOuvidoria ? (
          <Ajuda className="controle-fundo">
            <div dangerouslySetInnerHTML={{ __html: dadosCidade.configuracoes.TextoAjudaOuvidoria }} />
          </Ajuda>
        ) : (
          <Ajuda className="controle-fundo">
            A Ouvidoria Municipal é o principal meio de comunicação entre o cidadão e a administração pública.
            Através dela, podem ser enviadas manifestações de diversos tipos, tais quais: denúncias, elogios,
            reclamações, solicitações e sugestões. Participe ativamente da sua cidade e entre em contato com a Ouvidoria através do eOuve.
          </Ajuda>
        )}
      </JanelaAjuda>
    </ContainerJanela>
  );
};

ModalAjuda.propTypes = {
  sic: PropTypes.bool,
  zeladoria: PropTypes.bool,
};

ModalAjuda.defaultProps = {
  sic: false,
  zeladoria: false,
};

export default ModalAjuda;
